import { FaExclamationTriangle,FaPrint, FaShareAlt, FaCheckCircle ,FaTimes} from "react-icons/fa";

export function PriceWarningModal({
  t,
  onManual,
  onSettings,
}) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-gray-900/60 backdrop-blur-sm">
      <div className="bg-white rounded-3xl p-6 w-full max-w-sm text-center shadow-2xl">
        <div className="w-16 h-16 bg-yellow-100 text-yellow-600 rounded-full flex items-center justify-center mx-auto mb-4">
          <FaExclamationTriangle size={32} />
        </div>

        <h3 className="text-xl font-bold text-gray-900">
          {t("milkEntry.price_warning.title")}
        </h3>

        <p className="text-gray-500 mt-2 mb-6 text-sm">
          {t("milkEntry.price_warning.msg")}
        </p>

        <div className="flex flex-col gap-3">
          <button
            onClick={onManual}
            className="w-full py-3 bg-gray-100 text-gray-800 font-bold rounded-xl hover:bg-gray-200"
          >
            {t("milkEntry.price_warning.manual_btn")}
          </button>

          <button
            onClick={onSettings}
            className="w-full py-3 bg-indigo-600 text-white font-bold rounded-xl hover:bg-indigo-700"
          >
            {t("milkEntry.price_warning.settings_btn")}
          </button>
        </div>
      </div>
    </div>
  );
}

export function ReceiptModal({
  t,
  Name,
  onPrint,
  onShare,
  onClose,
}) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-gray-900/60 backdrop-blur-sm">
      <div className="bg-white w-full max-w-sm rounded-3xl overflow-hidden shadow-2xl">
        <div className="p-6 text-center">
          <div className="w-16 h-16 bg-green-100 text-green-600 rounded-full flex items-center justify-center mx-auto mb-4">
            <FaCheckCircle size={32} />
          </div>
          <h3 className="text-xl font-bold text-gray-900">
            {t("milkEntry.messages.success_title")}
          </h3>
          <p className="text-gray-500 text-sm mt-1">
            {t("milkEntry.messages.record_msg")} {Name}
          </p>
        </div>

        <div className="px-6 pb-8 space-y-3">
          <button
            onClick={onPrint}
            className="w-full flex items-center justify-center gap-3 py-3 bg-gray-900 text-white rounded-xl font-semibold hover:bg-black transition-colors"
          >
            <FaPrint /> {t("milkEntry.messages.print")}
          </button>

          <button
            onClick={onShare}
            className="w-full flex items-center justify-center gap-3 py-3 bg-indigo-50 text-indigo-700 rounded-xl font-semibold hover:bg-indigo-100 transition-colors"
          >
            <FaShareAlt /> {t("milkEntry.messages.share_wa")}
          </button>

          <button
            onClick={onClose}
            className="w-full py-3 text-gray-400 text-sm font-medium hover:text-gray-600"
          >
            {t("milkEntry.messages.dismiss")}
          </button>
        </div>
      </div>
    </div>
  );
}

export function MissingCustomerModal({ t, onClose }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-red-900/20 backdrop-blur-md">
      <div className="bg-white rounded-2xl p-6 max-w-xs text-center shadow-xl border border-red-100">
        <div className="w-12 h-12 bg-red-100 text-red-600 rounded-full flex items-center justify-center mx-auto mb-4">
          <FaTimes />
        </div>

        <h3 className="font-bold text-gray-900">
          {t("milkEntry.messages.no_cust_title")}
        </h3>
        <p className="text-sm text-gray-500 mt-2">
          {t("milkEntry.messages.no_cust_msg")}
        </p>

        <button
          onClick={onClose}
          className="mt-6 w-full py-2 bg-gray-900 text-white rounded-lg"
        >
          {t("milkEntry.messages.okay")}
        </button>
      </div>
    </div>
  );
}